/**
 * Header menus: the desktop mega menu (hover open/close, and the SHOP panel's
 * testimonial carousel, product-card hover sync and tabs) and the mobile menu
 * drawer's testimonial carousel.
 *
 * These were inline scripts in snippets/header-mega-menu.liquid and
 * snippets/header-drawer.liquid, printed into every page's HTML. As one deferred
 * asset they're downloaded once and cached. Loaded from sections/header.liquid;
 * each part is a no-op when its markup isn't on the page (the mega menu only
 * renders for the mega-menu desktop style). Bindings are remembered per element,
 * so a theme-editor re-render of the header binds its new elements once.
 */
(function () {
  'use strict';
  if (window.JiYuHeaderMenus) return;

  var bound = new WeakSet();
  var shopBound = new WeakSet();

  /* Desktop mega menu ------------------------------------------------------ */

  function initMegaMenus() {
    document.querySelectorAll('.mega-menu').forEach(function (menu) {
      if (bound.has(menu)) return;
      bound.add(menu);
      var closeTimer;
      menu.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        menu.setAttribute('open', '');
      });
      menu.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(function () {
          menu.removeAttribute('open');
        }, 300);
      });
    });

    if (!escapeBound) {
      escapeBound = true;
      document.addEventListener('keydown', closeHoverMenusOnEscape);
    }

    var shopMenu = document.querySelector('.mega-menu');
    if (shopMenu) initShopMenu(shopMenu);
  }

  /* Escape closes a menu opened by hover (WCAG 1.4.13). Dawn's onKeyUpEscape
     (global.js) only hears keys from focus inside the <details>, and a hover
     open leaves focus wherever it was, so Escape did nothing. A menu holding
     focus is left to Dawn's handler, which also returns focus to its summary.
     The pointer can stay put: the menu reopens on the next mouseenter. */
  var escapeBound = false;
  function closeHoverMenusOnEscape(event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;
    document.querySelectorAll('.mega-menu[open]').forEach(function (menu) {
      if (menu.contains(document.activeElement)) return;
      menu.removeAttribute('open');
      var summary = menu.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    });
  }

  /* Lazy-init the testimonial Swiper when the Shop menu opens: on hover, or on
     the <details> toggle when the keyboard opens it. Hover alone left a
     keyboard user with testimonial arrows that did nothing and tabs that never
     switched (TASKS #161). */
  function initShopMenu(shopMenu) {
    if (shopBound.has(shopMenu)) return;
    shopBound.add(shopMenu);

    var navSwiperInstance = null;
    var shopMenuReady = false;

    function initNavTestimonialSwiper() {
      if (navSwiperInstance) return;
      var el = document.querySelector('.nav-testimonial-swiper');
      if (!el || typeof Swiper === 'undefined') return;

      /* loop: false because with only 3 nav_testimonial blocks, Swiper silently
         disables loop mode (no swiper-slide-duplicate slides get created), which
         makes slideToLoop() a no-op and breaks the product-card hover sync below.
         If more testimonials are added (5+), this can be flipped back to true and
         the hover handler switched back to slideToLoop. */
      navSwiperInstance = new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        pagination: {
          el: '.nav-testimonial-pagination',
          clickable: true,
        },
      });

      /* The arrows go to swiper-arrows.js, not Swiper's navigation, which
         disables the end arrow and drops keyboard focus out of the menu.
         blurAtEnd: false keeps a mouse click on the last testimonial from
         letting go of focus too: header-menu closes on focusout, so the menu
         used to close under the pointer. */
      if (window.JiYuSwiperArrows) {
        window.JiYuSwiperArrows.wire(navSwiperInstance, {
          prevEl: el.querySelector('.nav-testimonial-prev'),
          nextEl: el.querySelector('.nav-testimonial-next'),
          blurAtEnd: false,
        });
      }
    }

    function setUpShopMenu() {
      initNavTestimonialSwiper();
      if (!navSwiperInstance || shopMenuReady) return;
      shopMenuReady = true;

      /* Sync product card hover -> testimonial slide. */
      var cards = document.querySelectorAll('.jiyu-card--link[data-product-handle]');

      /* Map product handle -> first real slide index. */
      var handleToIndex = {};
      document.querySelectorAll('.nav-testimonial-swiper .swiper-slide:not(.swiper-slide-duplicate)').forEach(function (slide, idx) {
        var h = slide.dataset.productHandle;
        if (h && !(h in handleToIndex)) handleToIndex[h] = idx;
      });

      cards.forEach(function (card) {
        card.addEventListener('mouseenter', function () {
          var handle = this.dataset.productHandle;
          if (!handle || !(handle in handleToIndex)) return;
          /* slideTo (not slideToLoop) because loop mode is off above. */
          navSwiperInstance.slideTo(handleToIndex[handle], 300);
        });
      });

      /* Tabbed mega menu: hover/click/focus switches the active tab. Looks up the
         tabbed wrapper inside the Shop submenu so this stays a no-op when the
         merchant hasn't enabled tabbed mode in section settings. */
      var tabbedWrap = shopMenu.querySelector('.menu-with-wrap--tabbed');
      if (!tabbedWrap) return;
      var tabButtons = tabbedWrap.querySelectorAll('.nav-tab');
      var tabbedGrid = tabbedWrap.querySelector('.jiyu-mega-grid[data-active-tab]');
      if (!tabButtons.length || !tabbedGrid) return;
      var activateTab = function (tabEl) {
        var tabNum = tabEl.dataset.megamenuTab;
        if (!tabNum) return;
        tabButtons.forEach(function (t) {
          var isActive = t === tabEl;
          t.classList.toggle('is-active', isActive);
          t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        tabbedGrid.setAttribute('data-active-tab', tabNum);
      };
      tabButtons.forEach(function (tab) {
        /* Hover is the primary interaction. Focus + click also activate for
           keyboard / pointer users. Click stopPropagation so the surrounding
           <details>/<summary> doesn't collapse the menu when the merchant clicks
           a tab in preview. */
        tab.addEventListener('mouseenter', function () { activateTab(this); });
        tab.addEventListener('focus', function () { activateTab(this); });
        tab.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          activateTab(this);
        });
      });
    }

    shopMenu.addEventListener('mouseenter', setUpShopMenu);
    shopMenu.addEventListener('toggle', function () {
      if (shopMenu.hasAttribute('open')) setUpShopMenu();
    });
  }

  /* Mobile menu drawer testimonial carousel ------------------------------- */

  /* Built the first time the menu opens rather than on every page load. It sits
     below the drawer's first screen (1,349 px down at 390 x 844), so building it
     just after the opening frame changes nothing anyone sees, and its ~13 ms
     build (4x CPU) stays out of the tap. The arrows go to swiper-arrows.js, not
     Swiper's navigation (CLAUDE.md, Carousels); blurAtEnd: false because the
     drawer closes on focusout. */
  function initMobileTestimonials() {
    var drawer = document.getElementById('Details-menu-drawer-container');
    var mobileEl = drawer && drawer.querySelector('.mobile-testimonial-swiper');
    if (!mobileEl || bound.has(drawer)) return;
    bound.add(drawer);

    function build() {
      if (mobileEl.swiper || typeof Swiper === 'undefined') return;

      /* Open on the current product's testimonial, if it has one. */
      var pathMatch = window.location.pathname.match(/\/products\/([^/?#]+)/);
      var currentHandle = pathMatch ? pathMatch[1] : null;
      var initialSlide = 0;
      if (currentHandle) {
        var realSlides = mobileEl.querySelectorAll('.swiper-slide');
        for (var i = 0; i < realSlides.length; i++) {
          if (realSlides[i].dataset.productHandle === currentHandle) {
            initialSlide = i;
            break;
          }
        }
      }

      var swiper = new Swiper(mobileEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        initialSlide: initialSlide,
        pagination: {
          el: mobileEl.querySelector('.mobile-testimonial-pagination'),
          clickable: true,
        },
      });

      if (window.JiYuSwiperArrows) {
        window.JiYuSwiperArrows.wire(swiper, {
          prevEl: mobileEl.querySelector('.mobile-testimonial-prev'),
          nextEl: mobileEl.querySelector('.mobile-testimonial-next'),
          blurAtEnd: false,
        });
      }
    }

    function buildAfterPaint() {
      if (!drawer.open || mobileEl.swiper) return;
      requestAnimationFrame(function () {
        setTimeout(build, 0);
      });
    }

    drawer.addEventListener('toggle', buildAfterPaint);
    /* A tap that opened the menu before this deferred file ran. */
    buildAfterPaint();
  }

  function init() {
    initMegaMenus();
    initMobileTestimonials();
  }

  window.JiYuHeaderMenus = { init: init };
  init();
  document.addEventListener('shopify:section:load', init);
})();
